import { makeStyles, Box } from "@material-ui/core";

import { COLORS } from "../../theme/colors";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: (props) => props.flexAlignment,
    height: (props) => props.containerHeight,
    margin: (props) => props.margin,
  },
  divider: {
    height: (props) => props.height,
    minHeight: (props) => props.minHeight,
    width: (props) => props.width,
    backgroundColor: (props) => props.color,
  },
}));

export const VerticalDivider = ({
  containerHeight = "auto",
  height = "100%",
  minHeight,
  width = "1px",
  color = COLORS.darks[0][25],
  margin,
  flexAlignment = "flex-start",
}) => {
  const classes = useStyles({
    flexAlignment,
    containerHeight,
    margin,
    height,
    minHeight,
    width,
    color,
  });

  return (
    <Box className={classes.root}>
      <Box className={classes.divider} />
    </Box>
  );
};
